import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import SalesBudgetYearInputImportLayout from 'components/organismos/master/storeManagement/salesBudgetYear/SalesBudgetYearInputImportLayout';

const salesBudgetYearInputImport = () => (
  <SidebarTemplate pageTitle="予算編成インポート">
    <SalesBudgetYearInputImportLayout />
  </SidebarTemplate>
);
export default salesBudgetYearInputImport;
